import useNativeSmt from '@swarm/core/hooks/data/useNativeSmt'
import useTransactionAlerts from '@swarm/core/hooks/i18n/useTransactionAlerts'
import { useAccount } from '@swarm/core/web3'
import { ExtendedSecurity } from '@swarm/types/normalized-entities'
import { useSnackbar } from '@swarm/ui/swarm/Snackbar'
import { BigSource } from 'big.js'
import { TransactionResult } from 'contract-proxy-kit'
import { useCallback, useState } from 'react'

import { SwarmStakingContract } from 'src/contracts/SwarmStakingContract'

type UseEditOfferState = {
  txLoading: boolean
}

type EnterStakingFunction = (
  selectedToken: ExtendedSecurity,
  amount: BigSource,
) => Promise<TransactionResult | void>

type UseEditOfferTokenReturn = [EnterStakingFunction, UseEditOfferState]

const useEnterStaking = (): UseEditOfferTokenReturn => {
  const [txLoading, setTxLoading] = useState(false)

  const { nativeSmt } = useNativeSmt()
  const account = useAccount()

  const { addError } = useSnackbar()
  const { track } = useTransactionAlerts()

  const enterStaking: EnterStakingFunction = useCallback(
    async (selectedToken, amount) => {
      if (!account || !nativeSmt) return

      setTxLoading(true)
      try {
        const tx = await SwarmStakingContract.enterStaking(
          selectedToken.id,
          amount,
          nativeSmt,
        )

        await track(tx, {
          confirm: {
            secondaryMessage: 'Staking joined succesffully',
          },
        })

        return tx
      } catch (e) {
        addError(e as Error)
      } finally {
        setTxLoading(false)
      }
    },
    [account, nativeSmt, track, addError],
  )

  return [enterStaking, { txLoading }]
}

export default useEnterStaking
